import {
  Component,
  OnInit,
  ViewContainerRef,
  Inject,
  ViewChild,
  ApplicationRef,
  ElementRef,
  HostBinding
} from '@angular/core';
import {Customer} from 'projects/app-misc/src/app/modules/customer/data/customer';
import {CustomerService} from 'projects/app-misc/src/app/modules/customer/data/customer.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {distinctUntilChanged, debounceTime, skip} from 'rxjs/operators';
import {Subject, timer} from 'rxjs';
import {NgForm} from '@angular/forms';
import {ContactInfo} from 'projects/app-misc/src/app/modules/customer/data/contactInfo';
import {CustomerWindowStore} from 'projects/app-misc/src/app/modules/customer/data/customer-window.store';
import {CustomerWindowQuery} from 'projects/app-misc/src/app/modules/customer/data/customer-window.query';
import {
  ProjectWindowComponent
} from 'projects/desktop/src/app/modules/project/view/project-window/project-window.component';
import {ProjectInfoComponent} from 'projects/mobile/src/app/modules/project/view/project-info/project-info.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {environment} from 'projects/desktop/src/environments/environment';
import {
  QbCustomerLinkDialogComponent
} from 'projects/desktop/src/app/modules/customer/view/customers-list/qb-customer-link-dialog/qb-customer-link-dialog.component';
import {ProjectService} from '../../../project-misc/data/project/project.service';
import {ConfirmationService} from 'primeng/api';
import {MvcExceptionResponse} from 'projects/core/src/lib/core/data/mvc-exception-response';
import {MiscSnackBarService} from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {CustomerProj} from '../../data/customer-in-proj';
import {ProjectFile} from '../../../project-misc/data/project/project-file';
import {PdfPreviewDialogComponent} from '../../../project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import {
  ImageGalleryCarouselComponent
} from '../../../project-misc/view/image-gallery-carousel/image-gallery-carousel.component';
import {API_URL} from '../../../../../../../core/src/lib/core/utils/tokens';
import {HttpEventType, HttpProgressEvent, HttpResponse} from '@angular/common/http';
import {FileUpload} from 'primeng/fileupload';
import {FileService} from '../../../../../../../core/src/lib/misc/data/file/file.service';
import {FileOpenerService} from '../../../project-misc/utils/fileOpener.service';

@Component({
  selector: 'app-customer-window',
  templateUrl: './customer-window.component.html',
  styleUrls: ['./customer-window.component.scss'],
  providers: [DeviceDetectorService, ConfirmationService]
})
export class CustomerWindowComponent implements OnInit {
  customer: Customer;

  header: string;

  @ViewChild('editCustomerForm', {static: false})
  editCustomerForm: NgForm;

  @ViewChild('fileUpload', {static: false})
  fileUploadForm: FileUpload;

  temporaryCustomer: Customer;

  customerNumber: number;

  customerLoading = true;

  openThisContact: number;

  @HostBinding('class.non-active-customer')
  nonActive: boolean;

  searchQuery: string;

  projectsLoading = true;
  projects: CustomerProj[];

  projectId: number;

  choosenContactsMap = new Map();

  qbConnected: boolean;

  letterLoadingIdMap = new Map();

  protected phoneChanges$ = new Subject<string>();

  isDesktop: boolean;
  isMobile: boolean;

  progressBar: number;

  filesLoading: boolean;

  customerFiles: ProjectFile[] = []

  constructor(
    @Inject(API_URL) protected apiUrl: string,
    protected miscSnackBarService: MiscSnackBarService,
    protected deviceDetectorService: DeviceDetectorService,
    protected dialog: MatDialog,
    protected dialogRef: MatDialogRef<CustomerWindowComponent>,
    protected customerService: CustomerService,
    protected projectService: ProjectService,
    protected viewContainerRef: ViewContainerRef,
    protected appRef: ApplicationRef,
    protected elementRef: ElementRef,
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
    protected confirmationService: ConfirmationService,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.customerNumber = data.id;
    this.projectId = data.projectId

    if (data.nfsContacts) {
      const contacts = (data.nfsContacts as ContactInfo[])
      contacts.forEach(con => {
        this.choosenContactsMap.set(con.id, con)
      })
    }
  }

  ngOnInit() {
    this.getCustomer();

    this.phoneChanges$.pipe(
      debounceTime(1000)
    ).subscribe(emit => {
      this.saveCustomer();
    })

  }

  getFiles() {
    this.filesLoading = true;
    this.customerService.getCustomerFiles(this.customer.id).subscribe(files => {
      this.customerFiles = files

      this.filesLoading = false;
    }, error => {
      this.filesLoading = false;
    })
  }

  getCustomer() {
    this.customerService.getCustomer(this.customerNumber).subscribe(customer => {
      this.customer = customer
      this.header = this.customer.name

      this.fillTempCustomer(customer)

      this.customerLoading = false;

      if (this.customer.qbId) {
        this.qbConnected = true;
      }

      this.qbConnected = this.customer.qbId ? true : false;

      this.customerService.getProjectsByCustomer(this.customerNumber).subscribe(projs => {
        this.projects = projs;
        this.projectsLoading = false;
        this.subToUpdate()
      })

      this.getFiles()
    })

  }

  fillTempCustomer(customer: Customer) {
    this.temporaryCustomer = Object.assign({}, customer)

    this.nonActive = !this.temporaryCustomer.active
    if (customer.billingInfoContact) {
      this.temporaryCustomer.billingInfoContact = Object.assign({}, customer.billingInfoContact)
    } else {
      this.temporaryCustomer.billingInfoContact = new ContactInfo();
    }
  }

  subToUpdate() {
    this.appRef.tick();

    this.editCustomerForm.valueChanges
      .pipe(
        debounceTime(1000),
        skip(1),
        distinctUntilChanged()
      ).subscribe(value => {
      this.saveCustomer()
    })

  }

  toggleActive() {
    this.temporaryCustomer.active = !this.temporaryCustomer.active
    this.saveCustomer();
    this.nonActive = !this.temporaryCustomer.active
  }

  telephoneChanged() {
    this.phoneChanges$.next(this.temporaryCustomer.billingInfoContact.phone1);
  }

  saveCustomer() {
    this.customerService.saveCustomer(this.temporaryCustomer).subscribe()
  }

  createNewContactBlock() {
    this.customerService.createContact(this.customer.id).subscribe(contact => {
      contact.name = 'New Contact'
      this.customer.contacts.push(contact)

      this.appRef.tick();

      this.openThisContact = this.customer.contacts.length - 1;

      timer(400).subscribe(() => {
        const toElem = this.elementRef.nativeElement.getElementsByClassName('new-contact-block')
        toElem[0].scrollIntoView({block: 'center', behavior: 'smooth'})

      })

      this.customerService.nfsContacts.next({
        allContacts: this.customer.contacts,
        selectedContacts: Array.from(this.choosenContactsMap.values())
      })
    })
  }

  deleteContact(contact: ContactInfo) {
    this.customerService.deleteContact(contact.id).subscribe(() => {
      const index = this.customer.contacts.indexOf(contact, 0);
      if (index > -1) {
        this.customer.contacts.splice(index, 1);
      }

      this.customerService.nfsContacts.next({
        allContacts: this.customer.contacts,
        selectedContacts: Array.from(this.choosenContactsMap.values())
      })
    })
  }

  // TODO Update with a delay
  updateHeader(contact: ContactInfo, newTitle?: string) {
    if (contact.phone1) {
      return contact.name + ' ' + contact.phone1
    } else {
      return contact.name
    }
  }

  openProject(projectId: number) {

    let projectWindow = ProjectWindowComponent as any;
    let panelClass = 'project-window-dialog'

    if (this.deviceDetectorService.isMobile() || this.deviceDetectorService.isTablet()) {
      projectWindow = ProjectInfoComponent
      panelClass = 'project-info-dialog'
    }

    const dialogRef = this.dialog.open(projectWindow, {
      data: {
        projectNumber: projectId
      },
      panelClass
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openQB() {
    const windowReference = window.open();
    let baseLink = `https://app.qbo.intuit.com`;
    let link = ``;
    const customerName = encodeURIComponent(this.customer.name)

    if (environment.dev) {
      baseLink = `https://app.sandbox.qbo.intuit.com`
    }

    if (this.customer.qbId) {
      link = `${baseLink}/app/customerdetail?nameId=${this.customer.qbId}`
    } else {
      link = `${baseLink}/app/search?searchCat=transaction&searchTransactionType=x999&searchValue=&searchAdvFieldArray=name&searchAdvFieldLabelArray=Display%20Name&searchAdvValueArray=${customerName}&searchAdvValueLabelArray=${customerName}&searchAdvOpArray=~`
    }

    windowReference.location.assign(link);
  }

  connectToQb() {
    const dialogRef = this.dialog.open(QbCustomerLinkDialogComponent, {
      data: {
        customerName: this.customer.name,
        customerId: this.customer.id,
        qbId: this.customer.qbId ? this.customer.qbId : null
      },
      panelClass: 'qb-link-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined') {
        if (result !== 'close-button') {
          if ((result as Customer).qbId) {

            this.customer = (result as Customer);
            this.fillTempCustomer((result as Customer))

            this.qbConnected = true;
            // this.getInfo();
          }
          // const fcust = this.customers.find(ccust => ccust.id === result.id);
          // if (fcust) {
          // 	fcust.qbId = result.qbId
          // 	fcust.qbDisplayName = result.qbDisplayName
          // }
        }
      }
    });
  }

  chooseContact(event, contact: ContactInfo) {
    event.stopPropagation();
    this.letterLoadingIdMap.set(contact.id, true)

    if (this.choosenContactsMap.has(contact.id)) {
      this.choosenContactsMap.delete(contact.id)
    } else {
      this.choosenContactsMap.set(contact.id, contact)
    }

    const notificationContacts = Array.from(this.choosenContactsMap.values());

    this.projectService.saveProject({
      id: this.projectId,
      notificationContacts
    }).subscribe(updated => {
      // this.choosenContact = contact;
      this.letterLoadingIdMap.delete(contact.id)

      this.customerService.nfsContacts.next({
        allContacts: this.customer.contacts,
        selectedContacts: notificationContacts
      })
    }, error => {
      this.letterLoadingIdMap.delete(contact.id)
      console.error('Something went wrong')

      this.miscSnackBarService.openErrorSnackBar(error.message)
    })
  }

  deleteCustomer() {
    this.confirmationService.confirm({
      header: 'Delete Customer?',
      message: `Customer ${this.customer.name} will be deleted`,
      accept: () => {
        this.customerService
          .deleteCustomer(this.customer.id)
          .subscribe(emit => {
              this.miscSnackBarService.openSuccessSnackBar('Customer Successfully Deleted!')

              this.dialogRef.close('DELETE');
              this.customerService.nfsContacts.next({
                allContacts: [],
                selectedContacts: []
              })

            },
            error => {
              if (error instanceof MvcExceptionResponse) {
                this.miscSnackBarService.openErrorSnackBar(error.message)
              }
            })
      }
    });
  }

  openFile(projectFile: ProjectFile) {
    this.fileOpenerService.openFile(projectFile, this.customerFiles, true)
  }

  getIcon(ext: string) {
    return this.fileService.getIcon(ext)
  }

  getTinyIcon(fileId: number) {
    return this.fileService.getImageThumbNail(fileId)
  }

  deleteFile(file: ProjectFile, index: number) {
    this.customerService.deleteCustomerFile(file.id, this.customer.id).subscribe(deleted => {
      this.customerFiles.splice(index, 1);
    })

  }

  uploadFiles(files, filesForm?) {
    const fileArray = [];

    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < files.length; i++) {
      fileArray.push(files[i])
    }

    this.progressBar = 1

    this.customerService.uploadCustomerFiles(fileArray, this.customer.id).subscribe(httpEvent => {
      if (httpEvent.type === HttpEventType.UploadProgress) {
        const progressEvent = httpEvent as HttpProgressEvent
        this.progressBar = Math.ceil(progressEvent.loaded / progressEvent.total * 100 / 3) * 3


      } else if (httpEvent.type === HttpEventType.Response) {
        const newFiles = (httpEvent as HttpResponse<ProjectFile[]>).body;
        this.customerFiles = this.customerFiles.concat(newFiles)
        this.progressBar = 0;
      }
      if (filesForm) {
        filesForm.clear();
      }
    }, error => {
      this.progressBar = 0
    })
  }

  onProgress(event) {
    this.progressBar = event.progress;

    if (this.progressBar === 100) {
    }
  }

  chooseFile() {
    this.fileUploadForm.choose()
  }
}
